import { render, staticRenderFns } from "./CampaignList.vue?vue&type=template&id=8713c632&scoped=true&"
import script from "./CampaignList.vue?vue&type=script&lang=ts&"
export * from "./CampaignList.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignList.vue?vue&type=style&index=0&id=8713c632&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8713c632",
  null
  
)

export default component.exports